import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cx-date-picker-activator" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<span class=\"cx-date-picker-activator__input-icon-wrapper\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" aria-hidden=\"true\" class=\"cx-date-picker-activator__input-icon\"><path d=\"M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z\"></path><path d=\"M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z\"></path><path d=\"M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z\"></path><path d=\"M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z\"></path></svg></span>", 1)
const _hoisted_4 = ["value", "disabled", "placeholder"]

import { computed } from 'vue';
import CxSpinner from '../CxSpinner.vue';
import CxLabel from '../CxLabel.vue';

interface Props {
  value?: string,
  disabled?: boolean,
  loading?: boolean
  placeholder?: string,
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CxDatePickerActivator',
  props: {
    value: {},
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    placeholder: {},
    label: {}
  },
  setup(__props: any) {

const props = __props;



const hideOnLoading = computed(() => {
  return props.loading ? 'visibility: hidden;' : 'visibility: visible;';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(CxLabel, {
          key: 0,
          class: "cx-date-picker-activator__label",
          label: _ctx.label
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "cx-date-picker-activator__input-container",
      disabled: _ctx.disabled
    }, [
      _createElementVNode("div", {
        class: "cx-date-picker-activator__input-wrapper",
        style: _normalizeStyle(hideOnLoading.value)
      }, [
        _hoisted_3,
        _createElementVNode("input", {
          class: "cx-date-picker-activator__activator-input",
          type: "text",
          value: _ctx.value,
          readonly: "",
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder
        }, null, 8, _hoisted_4)
      ], 4),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(CxSpinner, {
            key: 0,
            size: 15,
            width: 1
          }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ]))
}
}

})